import React, { memo, forwardRef } from "react";
const SvgCapitalEpsilon = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M19.432 17.216h-7.056v5.664h7.92c.448 0 .752.112.912.336.16.224.24.464.24.72 0 .256-.08.496-.24.72-.16.224-.464.336-.912.336h-8.88c-.944 0-1.416-.472-1.416-1.416V9.416C10 8.472 10.472 8 11.416 8h8.496c.448 0 .752.112.912.336.176.224.264.464.264.72 0 .144-.024.288-.072.432-.048.128-.168.264-.36.408-.176.128-.424.192-.744.192h-7.536v5.088h7.056c.432 0 .728.112.888.336.176.208.264.432.264.672 0 .144-.024.288-.072.432-.048.128-.168.264-.36.408-.176.128-.416.192-.72.192z"
      />
    </svg>
  );
});
SvgCapitalEpsilon.displayName = "SvgCapitalEpsilon";
const MemoForwardRef = memo(SvgCapitalEpsilon);
export default MemoForwardRef;
